import {
  BranchesOutlined,
  MinusCircleOutlined,
  RocketOutlined,
  SyncOutlined,
  ThunderboltOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

enum ScenarioBusinessPriority {
  one = '1',
  two = '2',
  three = '3',
  four = '4',
  five = '5',
}

export const scenarioBusinessPriorityAsString = (
  scenarioBusinessPriority: ScenarioBusinessPriority
): string => {
  switch (scenarioBusinessPriority) {
    case ScenarioBusinessPriority.one:
      return 'Optionnelle';
    case ScenarioBusinessPriority.two:
      return 'Secondaire';
    case ScenarioBusinessPriority.three:
      return 'Modérée';
    case ScenarioBusinessPriority.four:
      return 'Prioritaire';
    case ScenarioBusinessPriority.five:
      return 'Stratégique';
    default:
      return 'Neutre';
  }
};

export const renderScenarioBusinessPriorityOption = (scenarioBusinessPriority: ScenarioBusinessPriority): React.ReactNode => {
  switch (scenarioBusinessPriority) {
    case ScenarioBusinessPriority.one:
      return <>
        <BranchesOutlined style={{ marginRight: 6 }} />
        {scenarioBusinessPriorityAsString(scenarioBusinessPriority)} </>
    case ScenarioBusinessPriority.two:
      return <>
        <SyncOutlined style={{ marginRight: 6 }} />
        {scenarioBusinessPriorityAsString(scenarioBusinessPriority)} </>
    case ScenarioBusinessPriority.three:
      return <>
        <ThunderboltOutlined style={{ marginRight: 6 }} />
        {scenarioBusinessPriorityAsString(scenarioBusinessPriority)} </>
    case ScenarioBusinessPriority.four:
      return <>
        <RocketOutlined style={{ marginRight: 6 }} />
        {scenarioBusinessPriorityAsString(scenarioBusinessPriority)} </>
    case ScenarioBusinessPriority.five:
      return <>
        <TrophyOutlined style={{ marginRight: 6 }} />
        {scenarioBusinessPriorityAsString(scenarioBusinessPriority)} </>
    default:
      return <>
        <MinusCircleOutlined style={{ marginRight: 6 }} />
        {scenarioBusinessPriorityAsString(scenarioBusinessPriority)} </>
  }
};

export const scenarioBusinessPriorityAsNumber = (
  scenarioBusinessPriority: ScenarioBusinessPriority
): number => {
  switch (scenarioBusinessPriority) {
    case ScenarioBusinessPriority.one:
      return 1;
    case ScenarioBusinessPriority.two:
      return 2;
    case ScenarioBusinessPriority.three:
      return 3;
    case ScenarioBusinessPriority.four:
      return 4;
    case ScenarioBusinessPriority.five:
      return 5;
    default:
      return 0;
  }
};

export const scenarioBusinessPriorityAsEnum = (
  scenarioBusinessPriority: number
): ScenarioBusinessPriority => {
  switch (scenarioBusinessPriority) {
    case 1:
      return ScenarioBusinessPriority.one;
    case 2:
      return ScenarioBusinessPriority.two;
    case 3:
      return ScenarioBusinessPriority.three;
    case 4:
      return ScenarioBusinessPriority.four;
    case 5:
      return ScenarioBusinessPriority.five;
    default:
      return ScenarioBusinessPriority.one;
  }
};

export default ScenarioBusinessPriority;
